export const reduxKey = '@@pwa';

//# sourceMappingURL=constants.js.map